export interface Service {
  id: string
  title: string
  tagline: string
  description: string
  benefits: string[]
  idealFor: string[]
  icon: string
}

export const services: Service[] = [
  {
    id: 'janitorial',
    title: 'Janitorial Services',
    tagline: 'Spotless standards, every shift.',
    description: 'Daily, nightly, and specialty cleaning programs executed by trained, vetted teams using commercial-grade equipment and eco-friendly products.',
    benefits: ['Customized cleaning schedules', 'Green-certified products', 'Quality audits & reporting', 'Rapid response teams'],
    idealFor: ['Office buildings', 'Medical facilities', 'Educational institutions'],
    icon: 'Sparkles',
  },
  {
    id: 'security',
    title: 'Security Services',
    tagline: 'Protection you can see and feel.',
    description: 'Licensed security professionals delivering on-site guarding, mobile patrols, access control, and alarm response — protecting your people, property, and assets 24/7.',
    benefits: ['Licensed & insured guards', '24/7 mobile patrols', 'Access control & screening', 'Incident reporting & analytics'],
    idealFor: ['Commercial complexes', 'Residential towers', 'Industrial sites'],
    icon: 'Shield',
  },
  {
    id: 'building-maintenance',
    title: 'Building Maintenance',
    tagline: 'Proactive care, preserved value.',
    description: 'Preventive and reactive maintenance covering HVAC, plumbing, electrical, and general repairs — keeping your property running without interruption.',
    benefits: ['24/7 emergency response', 'Licensed technicians', 'Preventive schedules', 'Vendor management'],
    idealFor: ['Commercial complexes', 'Residential strata', 'Industrial properties'],
    icon: 'Wrench',
  },
  {
    id: 'day-porter',
    title: 'Day Porter Services',
    tagline: 'A constant presence, a flawless impression.',
    description: 'On-site personnel keeping your lobby, washrooms, and common areas immaculate throughout business hours. Visible service, invisible effort.',
    benefits: ['Uniformed professionals', 'Real-time issue resolution', 'Restocking & inspections', 'Tenant-facing support'],
    idealFor: ['Corporate headquarters', 'Shopping centres', 'Hospitality venues'],
    icon: 'Users',
  },
  {
    id: 'concierge',
    title: 'Concierge & Front Desk Staffing',
    tagline: 'The first impression, elevated.',
    description: 'Polished concierge professionals trained in hospitality, security awareness, and resident services for luxury and commercial properties.',
    benefits: ['Background-checked staff', 'Hospitality training', 'Access control protocols', 'Scalable staffing models'],
    idealFor: ['Luxury residential towers', 'Class A office buildings', 'Private clubs'],
    icon: 'UserCheck',
  },
  {
    id: 'exterior',
    title: 'Exterior Cleaning',
    tagline: 'Curb appeal that converts.',
    description: 'Pressure washing, window cleaning, and building envelope care that protects your property and enhances first impressions.',
    benefits: ['High-rise window access', 'Eco-safe pressure systems', 'Insured height work', 'Seasonal programs'],
    idealFor: ['High-rise towers', 'Retail plazas', 'Warehouses'],
    icon: 'Droplets',
  },
  {
    id: 'carpet-floor',
    title: 'Carpet & Floor Care',
    tagline: 'Surfaces that stay like new.',
    description: 'Deep extraction, polishing, stripping, and refinishing programs for every floor type — from marble lobbies to industrial concrete.',
    benefits: ['Deep-extraction equipment', 'Stone & marble specialists', 'Low-moisture options', 'Scheduled refinishing'],
    idealFor: ['Hotels & resorts', 'Corporate offices', 'Retail environments'],
    icon: 'Layers',
  },
  {
    id: 'post-construction',
    title: 'Post-Construction Cleaning',
    tagline: 'From hard hats to grand opening.',
    description: 'Rough, final, and fine clean phases executed to turn finished projects into move-in-ready spaces — on schedule, every time.',
    benefits: ['Phase-based execution', 'Debris removal', 'Detail-level finishing', 'Tight turnaround capability'],
    idealFor: ['Developers', 'General contractors', 'Property owners'],
    icon: 'HardHat',
  },
  {
    id: 'handyman',
    title: 'Handyman & Repairs',
    tagline: 'Small fixes. Big reliability.',
    description: 'Skilled handyman teams handling touch-ups, carpentry, hardware replacement, and small repairs across your portfolio.',
    benefits: ['Multi-skilled technicians', 'Same-week scheduling', 'Portfolio-wide coverage', 'Transparent billing'],
    idealFor: ['Property managers', 'Facility directors', 'Strata councils'],
    icon: 'Hammer',
  },
]
